import { Usuario } from '../../model/Usuario';
import { VendedorService } from '../../service/vendedor.service';
import { Component, OnInit } from '@angular/core';
import { ICadBase } from '../../model/ICadBase';
import { State } from '../../model/enumState';
import { MensagemService } from '../../service/mensagem.service';

@Component({
  selector: 'app-cad-vendedor',
  templateUrl: './cad-vendedor.component.html',
  styleUrls: ['./cad-vendedor.component.css']
})
export class CadVendedorComponent implements ICadBase, OnInit {
  public mostrar: boolean = true;
  constructor(public service: VendedorService, private msg: MensagemService) { }

  title: string = "Vendedor";
  titleExcluindo: string = "o vendedor";
  nome: string = "vendedor"
  ngOnInit() {

  }

  beforeSave(item, estado: State) {

  }
  public afterSave(item, that, calback) {
    return false;
  }

  NovoItem(item): any {
    var it = new Usuario();
    if (item) {
      it.Assing(item);
      it.Senha = "";
    }

    return it;

  }

  public InserindoAssincrono(item, that, calback, CancelLoading) {
    return false;
  }
  public EditandoAssincrono(item, that, calback) {
    return false;
  }

  public validoParaInserir(item): boolean {
   
    if (!item.Nome) {
      this.msg.Error("Nome deve ser informado");
      return false;
    }

    if (!item.Login) {
      this.msg.Error("Login deve ser informado");
      return false;
    }

    if (!item.Senha) {
      this.msg.Error("Senha deve ser informado");
      return false;
    }

    if (!item.Email) {
      this.msg.Error("E-mail deve ser informado");
      return false;
    }

    return true;
  }
  public validoParaEditar(item): boolean {
    if (!item.Nome) {
      this.msg.Error("Nome deve ser informado");
      return false;
    }

    if (!item.Login) {
      this.msg.Error("Login deve ser informado");
      return false;
    }

    if (!item.Email) {
      this.msg.Error("E-mail deve ser informado");
      return false;
    }

    return true;
  }

  EstadoChange(state: State) {

  }

}
